import { render, staticRenderFns } from "./LabelRequiredField.vue?vue&type=template&id=8c82fe6c&"
import script from "./LabelRequiredField.vue?vue&type=script&lang=js&"
export * from "./LabelRequiredField.vue?vue&type=script&lang=js&"
import style0 from "./LabelRequiredField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports